<template>
    <div class="" :class="{hidden: !loading}">
        <loading></loading>
    </div>
    <div :class="{hidden: loading}">
        <div v-if="meters.length">
            <form action="" class="form form--floating-label" @submit.prevent="formSubmit" ref='form' >

                <div v-for="meter in meters" :key="meter.id" class="mb-10">
                    <div class="style-emph mb-4">
                        {{ meter.name }}
                    </div>
                    <div class="shadow-100 rounded-lg ">
                        <div class="grid-cols-2 items-center grid py-3 px-7 style-body">
                            <div class="">
                                Last Reading:
                            </div>
                            <div class="text-right sm:text-left">
                                {{ meter.last_value }}
                            </div>
                            <div class="col-span-2 text-gray-500">
                                {{ dateFormat(meter.last_read_date) }}
                            </div>
                        </div>
                        <div class="grid-cols-2 items-center grid py-3 px-7 style-body border-t-2 border-gray">
                            <div class="">
                                New Reading:
                            </div>
                            <div class="text-right sm:text-left">
                                <input
                                        v-model="meter.new_value"
                                        type="number"
                                        class="h-9 w-28 px-3 transition-all border border-blue-gray rounded text-right"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="errors.message" class="bg-red text-white mb-5 px-3 py-2 rounded ">
                    {{ errors.message }}
                </div>

                <div v-if="showConfirmSkipValidation && !skipValidation" class="text-red mb-5 py-2 rounded ">
                    <div>
                        Your meter readings appear incorrect - please double check and, if correct, press Confirm to proceed
                    </div>
                </div>

                <div v-if="showConfirmSkipValidation && skipValidation" class="text-success mb-5 py-2 rounded flex items-center">
                    <i class="fas fa-check-circle text-2xl text-success mr-3"></i> Confirmed
                </div>


                <div class="mt-10 flex flex-col md:flex-row items-center ">
                    <button v-if="showConfirmSkipValidation" @click="confirm" type="button" class="btn w-full md:w-auto">Confirm and Update</button>
                    <button v-else type="submit" class="btn w-full md:w-auto">Update Meter Readings</button>
                    <a
                            @click="goBack"
                            class="mt-3 md:mt-0 md:ml-8 text-red hover:text-red-hover font-light underline cursor-pointer">Cancel Form</a>
                </div>
            </form>
        </div>

        <div v-else>
            Meter readings can not be updated online for this device, please <router-link :to="{ name: 'contact' }" class="text-red font-light underline">contact us</router-link>
            <div class="mt-4">
                <a
                        @click="goBack"
                        class="mt-3 md:mt-0 text-red hover:text-red-hover font-light underline cursor-pointer">Go Back</a>
            </div>
        </div>
    </div>


</template>

<script charset="utf-8">

import { values, join, get } from 'lodash';
import Loading from '../includes/Loading.vue';
import Vuex from 'vuex';

export default {
    name: 'MeterReadingsForm',
    props: ['equipmentID'],
    data() {
        return {
            loading: true,
            submittedOnce: false,
            skipValidation: false,
            showConfirmSkipValidation: false,
            errors: {}
        }
    },

    components: {
        Loading
    },
    computed: {
        ...Vuex.mapGetters('profile', {
            profile: 'profile'
        }),
        ...Vuex.mapGetters('equipments', {
            meters: 'meters',
            currentItem: 'currentItem'
        }),
    },

    created() {
        this.loading = true;
        this.getMeters(this.equipmentID)
            .then(() => {
                this.loading = false;
            })
    },
    emits: ["submit-success"],

    methods: {
        ...Vuex.mapActions('equipments', {
            getMeters: 'getMeters',
            updateMeters: 'updateMeters'
        }),

        dateFormat(value){
            if(value){
                return value.format('DD/MM/YYYY h:mm:ss a');
            }
            return 'No Reading';
        },

        confirm() {
            this.skipValidation = true;
            this.formSubmit();
        },

        formSubmit() {
            this.submittedOnce = true;
            this.errors.message = '';

            let data = {
                war_id: this.equipmentID,
                skip_validation: false,
                meter_readings: []
            };

            this.meters.forEach(meter => {
               if(meter.new_value){
                   data.meter_readings.push({
                       meter_id: meter.id,
                       value: meter.new_value
                   });
               }
            });

            if(data.meter_readings.length == 0){
                this.errors = {
                    message: 'Please insert the new reading value'
                }
                return;
            }
            this.loading = true;

            data['skip_validation'] = this.skipValidation;
            this.updateMeters(data)
                .then(() => {
                    this.$emit('submit-success');
                })
                .catch(err => {
                    let message = get(err, 'data.result');
                    if(message === 'validation_failed'){
                        this.showConfirmSkipValidation = true;
                    }else{
                        this.errors = {
                            message: get(err, 'response.data.errors.0.message')
                        }
                    }
                }).finally(() => {
                    this.loading = false;
                });
        },

        goBack(){
            if(!this.profile.isAuth()){
                this.$router.push({
                    name: 'autologin', query: { war_id: this.currentItem ? this.currentItem.id : '', serial: this.currentItem ? this.currentItem.serial : '' }
                });
            } else if(this.profile.isUser() || this.profile.isManager()){
                this.$router.push({
                    name: 'dashboard'
                });
            } else{
                this.$router.go(-1);
            }

        }
    }
}
</script>
